import {
  UPDATE_PRODUCT_PACKAGE,
  CREATE_PRODUCT_PACKAGE,
  START_LOADING,
  END_LOADING,
  PRODUCT_PACKAGE_ERROR,
  FETCH_PRODUCT_PACKAGE,
  FETCH_PRODUCT_PACKAGES,
  FETCH_PRODUCT_PACKAGES_BY_LANG,
  DELETE_PRODUCT_PACKAGE,
} from "../actions/constants";

const initialState = {
  packages: [],
  packagesByLang: [],
  loading: false,
  error: null,
  pkg: null,
};

const ProductPackageReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case END_LOADING:
      return {
        ...state,
        loading: false,
      };

    case CREATE_PRODUCT_PACKAGE:
      return {
        ...state,
        packages: [...state.packages, action.payload],
        loading: false,
        error: null,
      };

    case FETCH_PRODUCT_PACKAGES:
      return {
        ...state,
        packages: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
        loading: false,
        error: null,
      };

    case FETCH_PRODUCT_PACKAGES_BY_LANG:
      return {
        ...state,
        pkg: action.payload,
        loading: false,
        error: null,
      };

    case UPDATE_PRODUCT_PACKAGE:
      return {
        ...state,
        packages: state.packages.map((pkg) =>
          pkg._id === action.payload._id ? { ...pkg, ...action.payload } : pkg
        ),
      };

    case PRODUCT_PACKAGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCT_PACKAGE:
      return {
        ...state,
        packages: state.packages.filter((pkg) => pkg._id !== action.payload),
        pkg: state.pkg && state.pkg._id === action.payload ? null : state.pkg,
      };

    case FETCH_PRODUCT_PACKAGES_BY_LANG:
      return {
        ...state,
        packagesByLang: action.payload,
        error: null,
        loading: false,
      };

    default:
      return state;
  }
};

export default ProductPackageReducer;
